import React, { useEffect, useRef } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../css/notification.css";
import {
  DATA_LOAD_STATUS,
  DOC_CHECK_IN_TYPE,
} from "../redux/constants/metaData";
import { useMetadata } from "../redux/hooks/useMetadata";
import { useCheckin } from "../redux/hooks/useCheckin";
import { useTools } from "../redux/hooks/useTools";

function DialogMenu() {
  const metadata = useMetadata();
  const { attachedDocInfo } = useCheckin();
  const {
    onSucessDialogOkClick,
    onCopyLinkClick,
    onRowSelectionChange,
    onAttachedDocInfoChange,
  } = useTools();
  const viewCopyFail = metadata.viewCopyFail;
  const docCheckinType = metadata.docCheckinType;
  const loadIFSDocument = metadata.loadIFSDocument;
  const shownToastIdsRef = useRef(new Set());

  // useEffect(() => {
  //   if (docCheckinType === DOC_CHECK_IN_TYPE.none) {
  //     console.log("LoadIFSDocument:", loadIFSDocument);
  //     let currentToastId = null;

  //     if (
  //       attachedDocInfo !== null &&
  //       attachedDocInfo !== undefined &&
  //       attachedDocInfo !== "invalid"
  //     ) {
  //       currentToastId = `${attachedDocInfo.docClass}-${attachedDocInfo.docNo}-${attachedDocInfo.docRev}`;

  //       let doc = `${attachedDocInfo.docClass}-${attachedDocInfo.docNo}-${attachedDocInfo.docRev}-${attachedDocInfo.docSheet}`;
  //       let msg = "";

  //       if (viewCopyFail === true) {
  //         msg = `${attachedDocInfo.title} was successfully checked in ${doc}. But failed to upload view copy.`;
  //       } else {
  //         msg = `${attachedDocInfo.title} was successfully checked in ${doc}`;
  //       }

  //       if (loadIFSDocument === DATA_LOAD_STATUS.onLoad) {
  //         if (!shownToastIdsRef.current.has(currentToastId)) {
  //           shownToastIdsRef.current.add(currentToastId);

  //           toast.info(
  //             <div style={{ fontFamily: "Poppins, sans-serif" }}>
  //               <strong>
  //                 {viewCopyFail
  //                   ? "Partially checked in"
  //                   : "Successfully checked in"}
  //               </strong>
  //               <div style={{ fontSize: "12px", color: "#5b5b5c" }}>{msg}</div>
  //             </div>,
  //             {
  //               toastId: currentToastId,
  //               autoClose: false,
  //               hideProgressBar: true,
  //               icon: false,
  //               type: viewCopyFail ? "error" : "success",
  //               className: viewCopyFail ? "toast-custom-error" : "toast-custom",
  //             },
  //           );
  //         }
  //       } else if (loadIFSDocument === DATA_LOAD_STATUS.completed) {
  //         const renderContent = (
  //           <div style={{ fontFamily: "Poppins, sans-serif" }}>
  //             <strong>
  //               {viewCopyFail
  //                 ? "Partially checked in"
  //                 : "Successfully checked in"}
  //             </strong>
  //             <div style={{ fontSize: "12px", color: "#5b5b5c" }}>{msg}</div>
  //           </div>
  //         );

  //         toast.update(currentToastId, {
  //           render: renderContent,
  //           type: viewCopyFail ? "error" : "success",
  //           autoClose: 3000,
  //           hideProgressBar: false,
  //           icon: false,
  //           className: viewCopyFail ? "toast-custom-error" : "toast-custom",
  //         });

  //         let shareCopy = [
  //           {
  //             class: attachedDocInfo.docClass,
  //             docNo: attachedDocInfo.docNo,
  //             docRev: attachedDocInfo.docRev,
  //             docType: attachedDocInfo.docType,
  //             fileNo: 1,
  //             fileExtension: getFileExtension(attachedDocInfo.originalFileName),
  //             title: attachedDocInfo.title,
  //             fileType: getFileExtension(attachedDocInfo.originalFileName),
  //             sheetNo: attachedDocInfo.docSheet,
  //           },
  //         ];

  //         onRowSelectionChange(shareCopy);

  //         setTimeout(() => {
  //           onSucessDialogOkClick(false);
  //         }, 3000);
  //       }
  //     }
  //   }
  // }, [attachedDocInfo, loadIFSDocument]);

  function getFileExtension(fileName) {
    if (fileName) {
      return fileName.split(".").pop().toUpperCase();
    }
    return "";
  }

  return null;
}

export default DialogMenu;
